export default __webpack_public_path__ + "static/media/eye.05a99b0a.svg";